import { Fragment } from "react";

export type RichTextSegment = {
  text: string;
  bold?: boolean;
};

type CollectionsRichTextProps = {
  /** Ordered text segments, typically sourced from translations. */
  segments: RichTextSegment[];
  /** Class applied to segments flagged as `bold`. */
  boldClassName?: string;
};

/**
 * Renders an array of translation-sourced text segments, applying emphasis to
 * the ones flagged `bold`. Keeping emphasis as discrete segments (rather than
 * inline markup) lets each locale position the emphasized phrase naturally.
 */
export function CollectionsRichText({
  segments,
  boldClassName = "font-bold text-black",
}: Readonly<CollectionsRichTextProps>) {
  return (
    <>
      {segments.map((segment, index) => (
        <Fragment key={index}>
          {segment.bold ? (
            <span className={boldClassName}>{segment.text}</span>
          ) : (
            segment.text
          )}
        </Fragment>
      ))}
    </>
  );
}
